/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  VestaInterestManager,
  VestaInterestManagerInterface,
} from "../VestaInterestManager";

const _abi = [
  {
    inputs: [],
    name: "ErrorModuleAlreadySet",
    type: "error",
  },
  {
    inputs: [],
    name: "NotTroveManager",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDebt",
        type: "uint256",
      },
    ],
    name: "DebtChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestMinted",
        type: "uint256",
      },
    ],
    name: "InterestMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "ModuleLinked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "decreaseDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "interestDebt_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getInterestModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastVstPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getModules",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUserDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "currentDebt_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pendingInterest_",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "increaseDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "interestDebt_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_module",
        type: "address",
      },
    ],
    name: "setModuleFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vst",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateModules",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vst",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VestaInterestManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VestaInterestManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VestaInterestManager__factory extends ContractFactory {
  constructor(...args: VestaInterestManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<VestaInterestManager> {
    return super.deploy(overrides || {}) as Promise<VestaInterestManager>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VestaInterestManager {
    return super.attach(address) as VestaInterestManager;
  }
  override connect(signer: Signer): VestaInterestManager__factory {
    return super.connect(signer) as VestaInterestManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VestaInterestManagerInterface {
    return new utils.Interface(_abi) as VestaInterestManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VestaInterestManager {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as VestaInterestManager;
  }
}
